import { useEffect, useState } from "react";
import SharedDiv from "../../Components/SharedDiv/SharedDiv";
import Header from "../../Pages/Header";
import Navbar from "../../Pages/NavBar";

const MainLayoutSupmitter = ({ children }) => {
  const [showNav, setShowNav] = useState(false);
 
  useEffect(() => {
    if (
      !window.location.pathname.includes('mainpage') && 
      window.location.pathname !== "/grants/"
    ) {
      // If the current page's path does NOT include 'mainpage' 
      // AND the path is NOT exactly "/grants/", 
      // then show the navigation menu by setting `setShowNav` to `true`.
      setShowNav(true);
    } else {
      // Otherwise, hide the navigation menu by setting `setShowNav` to `false`.
      setShowNav(false);
    }
  }, [window.location.pathname]);

  return (
    <>
      <div>
        <Header />
        {showNav ? <Navbar /> : ""}
        <main>{children}</main>
      </div>
    </>
  );
};
export default MainLayoutSupmitter;
